if (!customElements.get('price-display')) {
  class PriceDisplay extends HTMLElement {
    connectedCallback() {
      this.state = {
        variant: {
          priceCents: parseInt(this.dataset.price, 10) || 0,
          compareAtCents: parseInt(this.dataset.compareAtPrice, 10) || 0,
          pixCents: parseInt(this.dataset.pixPrice, 10) || 0,
          available: this.dataset.available !== 'false',
          variantId: null
        },
        addons: { totalCents: 0, compareAtTotalCents: 0, pixTotalCents: 0 },
        isEnxoval: this.dataset.isEnxoval === 'true'
      };
      window.dispatchEvent(
        new CustomEvent('price-display:connected', {
          detail: { sectionId: this.dataset.sectionId }
        })
      );
    }

    setVariant({ priceCents, compareAtCents = 0, pixCents = 0, available = true, variantId = null }) {
      if (!this.state || !Number.isFinite(priceCents) || priceCents < 0) {
        console.warn('price-display: invalid setVariant payload', priceCents);
        return;
      }
      this.state.variant = {
        priceCents,
        compareAtCents: compareAtCents || 0,
        pixCents: pixCents || 0,
        available,
        variantId
      };
      this.render();
    }

    setAddons({ totalCents, compareAtTotalCents = 0, pixTotalCents = 0 }) {
      if (!this.state || !Number.isFinite(totalCents) || totalCents < 0) {
        console.warn('price-display: invalid setAddons payload', totalCents);
        return;
      }
      this.state.addons = {
        totalCents,
        compareAtTotalCents: compareAtTotalCents || 0,
        pixTotalCents: pixTotalCents || 0
      };
      this.render();
    }

    reset() {
      if (!this.state) return;
      this.state.addons = { totalCents: 0, compareAtTotalCents: 0, pixTotalCents: 0 };
      this.render();
    }

    getComputedPrices() {
      const rules = window.PriceRules;
      if (!rules || !this.state) return null;
      const { variant, addons, isEnxoval } = this.state;

      const variantPixCents =
        variant.pixCents > 0 ? variant.pixCents : rules.computePixPrice(variant.priceCents, isEnxoval);
      const addonsPixCents =
        addons.totalCents > 0
          ? addons.pixTotalCents > 0
            ? addons.pixTotalCents
            : rules.computePixPrice(addons.totalCents, false)
          : 0;

      const totalCents = variant.priceCents + addons.totalCents;
      const compareCents =
        variant.compareAtCents > 0 || addons.compareAtTotalCents > 0
          ? (variant.compareAtCents > 0 ? variant.compareAtCents : variant.priceCents) +
            addons.compareAtTotalCents
          : 0;

      return {
        totalCents,
        totalPixCents: variantPixCents + addonsPixCents,
        compareCents,
        installments: rules.computeInstallments(totalCents),
        isEnxoval,
        available: variant.available
      };
    }

    render() {
      const rules = window.PriceRules;
      const computed = this.getComputedPrices();
      if (!rules || !computed) return;
      if (!computed.available || this.state.variant.priceCents <= 0) return;

      const { totalCents, totalPixCents, compareCents, installments } = computed;

      const priceBlock = this.querySelector('.price') || this;
      priceBlock.classList.toggle('price--on-sale', compareCents > totalCents);

      const pixText = rules.formatMoney(totalPixCents);
      const regularPixEl =
        this.querySelector('.price__regular .price-item--sale p') ||
        this.querySelector('.price__regular p');
      if (regularPixEl) regularPixEl.textContent = pixText;

      const salePixEl = this.querySelector('.price__sale .price-item--sale p');
      if (salePixEl) salePixEl.textContent = pixText;

      const regularDeEl = this.querySelector('.price__regular s, .price__regular .price-item--regular');
      if (regularDeEl) regularDeEl.textContent = `De: ${rules.formatMoney(totalCents)}`;

      const saleDeEl = this.querySelector('.price__sale s, .price__sale .price-item--regular');
      if (saleDeEl) {
        saleDeEl.textContent = compareCents > 0 ? `De: ${rules.formatMoney(compareCents)}` : '';
      }

      const installmentsEl = this.querySelector('.ec-card-price-installments');
      if (installmentsEl) {
        installmentsEl.innerHTML = `<div class="installments">Ou <b>${rules.formatMoney(totalCents)}</b> em até ${installments.count}x de ${rules.formatMoney(installments.valueCents)} s/ juros</div>`;
      }

      this.querySelectorAll('[data-original-price]').forEach((el) => {
        el.setAttribute('data-original-price', this.state.variant.priceCents);
      });

      window.dispatchEvent(
        new CustomEvent('product:price-updated', {
          detail: { sectionId: this.dataset.sectionId, variantId: this.state.variant.variantId }
        })
      );
    }
  }

  customElements.define('price-display', PriceDisplay);
}
